var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.MedicationDetail.template_type == 0)?_c('div',[_c('MedicationDetail')],1):(_vm.MedicationDetail.template_type == 1)?_c('div',[_c('MedicationDetailNew')],1):_c('div',[_c('MedicationDetailTabs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }